'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.timelineSettings',
configs:[
require('./timelineSettingsConfig')],

components:[
require('./timelineSettingsController')]});
//# sourceMappingURL=index.js.map
